var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsle48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_8892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.00012207C37.2548 -0.00012207 48 10.745 48 23.9999H0C0 10.745 10.7452 -0.00012207 24 -0.00012207Z",
    fill: "#F1564C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9998 6.99988C33.3886 6.99988 40.9998 14.611 40.9998 23.9999H6.99976C6.99976 14.611 14.6109 6.99988 23.9998 6.99988Z",
    fill: "#FC8B46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14.9999C28.9706 14.9999 33 19.0293 33 23.9999H15C15 19.0293 19.0294 14.9999 24 14.9999Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94069 26.9999H21.0897C21.8663 26.9999 22.4958 27.6325 22.4958 28.4129C22.4958 28.7231 22.3942 29.0247 22.2067 29.2712L12.2378 42.3704C11.7025 43.0738 10.701 43.208 10.001 42.6701C9.8888 42.5839 9.78851 42.4831 9.70273 42.3704L0.395871 30.1411C-0.256561 29.2838 -0.0938224 28.0573 0.759358 27.4017C1.09855 27.1411 1.51369 26.9999 1.94069 26.9999Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9063 26.9999H46.0553C47.1293 26.9999 48 27.8748 48 28.954C48 29.3831 47.8595 29.8002 47.6001 30.1411L38.2932 42.3704C37.7579 43.0738 36.7564 43.208 36.0564 42.6701C35.9442 42.5839 35.8439 42.4831 35.7581 42.3704L25.7892 29.2712C25.3175 28.6513 25.4352 27.7645 26.0521 27.2904C26.2973 27.102 26.5975 26.9999 26.9063 26.9999Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99976 26.9999H40.9998L25.3449 47.3367C24.7709 48.0825 23.7032 48.2199 22.9603 47.6436C22.8458 47.5548 22.7431 47.4517 22.6546 47.3367L6.99976 26.9999Z",
    fill: "#5F6257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 26.9999H31.9998L24.5566 36.7253C24.3223 37.0314 23.883 37.0905 23.5755 36.8573C23.5256 36.8194 23.481 36.775 23.443 36.7253L15.9998 26.9999Z",
    fill: "#919078"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_8892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsle48);
export default __webpack_public_path__ + "static/media/isle48.1c1595dbed97a76e30eea44e6232a415.svg";
export { ForwardRef as ReactComponent };